;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

export type ListUserOrganizationsQueryVariables = {
  first?: number
  last?: number
  after?: string
  before?: string
  pUserId: number
}

export type ListUserOrganizationsQueryData = {
  listUserOrganizations?: {
    edges?: Array<{
      cursor?: string
      node?: {
        isPersonal?: boolean | null
        orgId?: string | number | null
        orgName?: string | null
        role?: string | null
      } | null
    } | null>
    totalCount?: number
  } | null
}

const listUserOrganizations = gql`
  query listUserOrganizations(
    $first: Int
    $last: Int
    $after: Cursor
    $before: Cursor
    $pUserId: Int!
  ) {
    listUserOrganizations(
      first: $first
      last: $last
      after: $after
      before: $before
      pUserId: $pUserId
    ) {
      edges {
        cursor
        node {
          isPersonal
          orgId
          orgName
          role
        }
      }
      totalCount
    }
  }
`

export default listUserOrganizations
